// Types
import Reducers from 'app/types/Reducers';
// Actions
import { AppUiNotificationsActions } from 'app/store/AppUINotifications/AppUINotifications.slice';
// Messages
import Messages from "./Contacts.messages";
// Utilities
import asyncThunkHandler from "app/utilities/AsyncThunkHandler";
import { $get, $post, $put, $delete } from 'app/utilities/HttpClient';

const _url:string = '/contacts';

// Get contacts
export const getContacts = asyncThunkHandler(
  `${Reducers.Contacts}/Get contacts`,
  async (params:any) => {
    const response:Response = await $get(_url, params);
    return response.json();
  }
);
// Get contacts autocomplete
export const getContactsAutocomplete = asyncThunkHandler(
  `${Reducers.Contacts}/Get contacts autocomplete`,
  async (params:any) => {
    const response:Response = await $get(_url, params);
    return response.json();
  }
);
// Get contact
export const getContact = asyncThunkHandler(
  `${Reducers.Contacts}/Get contact`,
  async (contactId:number) => {
    const response:Response = await $get(`${_url}/${contactId}`);
    return response.json();
  }
);
// Create contact
export const createContact = asyncThunkHandler(
  `${Reducers.Contacts}/Create contact`,
  async (data:any, { dispatch }) => {
    const response:Response = await $post(_url, data);
    dispatch(AppUiNotificationsActions.addSnackbar({
      message: Messages.Create
    }));
    return response.json();
  }
);
// Update contact
export const updateContact = asyncThunkHandler(
  `${Reducers.Contacts}/Update contact`,
  async ({ contactId, data }:{ contactId:number, data:any }, { dispatch }) => {
    const response:Response = await $put(`${_url}/${contactId}`, data);
    dispatch(AppUiNotificationsActions.addSnackbar({
      message: Messages.Update
    }));
    return response.json();
  }
);
// Delete contact
export const deleteContact = asyncThunkHandler(
  `${Reducers.Contacts}/Delete contact`,
  async (contactId:number, { fulfillWithValue, dispatch }) => {
    await $delete(`${_url}/${contactId}`);
    dispatch(AppUiNotificationsActions.addSnackbar({
      message: Messages.Delete
    }));
    return fulfillWithValue(contactId);
  }
);
